import { useEffect } from 'react';

/**
 * Hook that calls a callback function when the Escape key is pressed
 * @param onEscape - Callback function to execute when Escape is pressed
 */
export const useCloseOnEscape = (onEscape: () => void) => {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onEscape();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onEscape]);
};
